import { RubricStats, RubricsStatus } from 'generated/graphql';
import orderBy from 'lodash/orderBy';

type Rubric = Omit<RubricStats, 'totalReviewCount' | '__typename'> & Partial<Pick<RubricStats, 'totalReviewCount'>>;

const sortRubrics = <T extends Rubric>(rubrics: T[]): T[] => {
    const favoriteRubrics: T[] = [];
    const unArchivedUnfavoriteRubrics: T[] = [];
    const archivedUnfavoriteRubrics: T[] = [];

    rubrics.forEach((rubric) => {
        if (rubric.favorite) {
            favoriteRubrics.push(rubric);
        } else if (rubric.status === RubricsStatus.Archived) {
            archivedUnfavoriteRubrics.push(rubric);
        } else {
            unArchivedUnfavoriteRubrics.push(rubric);
        }
    });

    const sortedFavoriteRubricsAlphabetically = orderBy(favoriteRubrics, ['nameLowerCase'], ['asc']);

    const sortedUnArchivedUnfavoriteRubricsByDate = orderBy(unArchivedUnfavoriteRubrics, ['createdDate'], ['desc']);

    const sortedArchivedUnfavoriteRubricsByDate = orderBy(archivedUnfavoriteRubrics, ['createdDate'], ['desc']);

    return [
        ...sortedFavoriteRubricsAlphabetically,
        ...sortedUnArchivedUnfavoriteRubricsByDate,
        ...sortedArchivedUnfavoriteRubricsByDate,
    ];
};

export default sortRubrics;
